export default __webpack_public_path__ + "assets/models/6bfb559928dba32e3eb5d53a20bb94be.glb";